import _ from 'lodash';
import {ReducerActionAttributes} from '~/redux/reducers/RootReducer';
import {UserHintsAttributes} from '../reducers/UserReducer';

export enum UserAction {
    LOG_IN = 'LOG_IN',
    LOG_OUT = 'LOG_OUT',
    RECEIVE_USER_HINTS = 'RECEIVE_USER_HINTS',
}

const {LOG_IN, LOG_OUT, RECEIVE_USER_HINTS} = UserAction;

export const logUserIn = (authToken: string): ReducerActionAttributes<UserAction, string> => ({
    type: LOG_IN,
    value: authToken,
});

export const logUserOut = (): ReducerActionAttributes<UserAction, undefined> => ({
    type: LOG_OUT,
    value: undefined,
});

export const receiveUserHints = (
    userHints: UserHintsAttributes
): ReducerActionAttributes<UserAction, UserHintsAttributes> => ({
    type: RECEIVE_USER_HINTS,
    value: userHints,
});
